import { render, staticRenderFns } from "./SocialLarge.vue?vue&type=template&id=eb9aa4ea&"
import script from "./SocialLarge.vue?vue&type=script&lang=js&"
export * from "./SocialLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports